import React from "react";
const ThinkingLargeIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={62}
      height={62}
      viewBox="0 0 62 62"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd">
        <circle cx={31} cy={31} r={31} />
        <path
          d="M26.875 35.795s14.732-3.75 20.625 3.75M23.75 14.944s5-5 10 0M40.75 16.639s5 5 10 0"
          stroke="#000"
          strokeWidth={3}
        />
        <path d="M31 0c17.12 0 31 13.88 31 31 0 17.12-13.88 31-31 31C13.88 62 0 48.12 0 31c0-.516.013-1.029.038-1.539C.798 44.246 13.026 56 28 56c15.464 0 28-12.536 28-28C56 13.026 44.246.798 29.462.037 29.97.013 30.484 0 31 0z" />
        <path d="M31 0c10.09 0 19.055 4.82 24.716 12.285A30.863 30.863 0 0037 6C19.88 6 6 19.88 6 37c0 7.03 2.34 13.514 6.284 18.715C4.821 50.055 0 41.09 0 31 0 13.88 13.88 0 31 0z" />
        <circle stroke="#000" strokeWidth={3} cx={31} cy={31} r={29.5} />
        <circle cx={29} cy={22} r={4} />
        <circle cx={45} cy={26} r={4} />
        <path d="M11 52V36a4 4 0 014-4h3a4 4 0 014 4v4.999h18A4 4 0 0144 45v3a4 4 0 01-4 4l-7.001-.001V57A5 5 0 0128 62h-7c-5.523 0-10-4.477-10-10z" />
        <path
          d="M18 33.5c.69 0 1.315.28 1.768.732.452.453.732 1.078.732 1.768h0v6.499H40c.69 0 1.315.28 1.768.733.452.453.732 1.078.732 1.768h0v3c0 .69-.28 1.315-.732 1.768a2.492 2.492 0 01-1.767.732h0l-8.502-.001V57c0 .94-.369 1.792-.97 2.42a3.488 3.488 0 01-2.347 1.076h0L21 60.5a8.473 8.473 0 01-6.01-2.49A8.473 8.473 0 0112.5 52h0V36c0-.69.28-1.315.732-1.768A2.492 2.492 0 0115 33.5h0z"
          stroke="#000"
          strokeWidth={3}
        />
      </g>
    </svg>
  )
);
ThinkingLargeIcon.displayName = "ThinkingLargeIcon";
export default ThinkingLargeIcon;
